import React from "react";

const DashboardHome = () => {
  return (
    <div>
      <img
        className="welcome img-fluid mt-5"
        src="https://i.ibb.co/GWZ4V53/To-Dashboard.png"
        alt=""
      />
    </div>
  );
};

export default DashboardHome;
